// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * NodeHandle — Reusable theme-aware handle for SolyticsFlow nodes.
 *
 * Eliminates duplication of inline handle styles across every node type.
 * Default styling uses the workflow/lineage handle token; callers may
 * override via the `color` prop when needed.
 *
 * Accepted props (all others are intentionally blocked):
 *   type     — 'source' | 'target'
 *   position — handle placement (Position.Left / Right / Top / Bottom)
 *   id       — unique handle identifier within the node
 *   color    — optional hex/token override for the dot colour
 *   size     — handle diameter in px (default 6)
 *   offset   — { top?, left?, bottom?, right? } CSS offset overrides for exact placement
 *              (e.g. { top: '30%' } to position at 30% of the node height)
 */
import React, { memo, useMemo } from 'react';
import { Handle } from 'reactflow';
import { useTheme } from '@mui/material/styles';
import { resolveThemeColor } from './themeColorUtils';

const NodeHandle = memo(({ type, position, id, color, size = 6, offset }) => {
  const theme = useTheme();

  const handleStyle = useMemo(
    () => ({
      width: size,
      height: size,
      borderRadius: '50%',
      background:
        resolveThemeColor(theme, color, 'solyticsFlow.node.handleColor') ||
        theme.palette.grey?.[400] ||
        '#BCBCBC',
      border: 'none',
      ...offset,
    }),
    [color, size, theme, offset]
  );

  return <Handle type={type} position={position} id={id} style={handleStyle} />;
});
NodeHandle.displayName = 'NodeHandle';

export default NodeHandle;
